module.exports = "/labor-cost/components/laborCostPreviewComponent-2ef00b.html";